import { render } from "./ArtInvestHotelsComponent.vue?vue&type=template&id=6791e7e4&scoped=true"
import script from "./ArtInvestHotelsComponent.vue?vue&type=script&lang=js"
export * from "./ArtInvestHotelsComponent.vue?vue&type=script&lang=js"

import "./ArtInvestHotelsComponent.vue?vue&type=style&index=0&id=6791e7e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6791e7e4"]])

export default __exports__